import BaseApi from './base'

class Section extends BaseApi {
  getSections = (query) => this.client.get(`admin/sections?${query}`)

  getSection = (id) => this.client.get(`admin/sections/${id}`)

  addSection = (data) => this.client.post('admin/sections', data)

  updateSection = (id, data) => this.client.patch(`admin/sections/${id}`, data)

  getComponents = (id, query) =>
    this.client.get(`admin/sections/${id}/component?${query}`)

  addComponent = ({ sectionId, params }) =>
    this.client.post(`admin/sections/${sectionId}/component`, params)

  updateComponent = ({ componentId, params }) =>
    this.client.patch(`admin/sections/component/${componentId}`, params)

  updateComponentTranslation = (id, data) =>
    this.client.post(`admin/sections/component/${id}/translation`, data)

  getSystemSections = (query) =>
    this.client.get(`show-case-website/sections?${query}`)
}

export default new Section()
